import React from 'react';
import './OfferOptionTileExtra.scss';

interface OfferOptionTileExtraProps {
  title: string;
  items: Array<string>;
  iconElement: React.ReactNode;
}

const OfferOptionTileExtra: React.FC<OfferOptionTileExtraProps> = ({
  title,
  items,
  iconElement,
}) => (
  <div className="offer-option-tile-extra">
    <div className="offer-option-tile-extra__list">
      <div className="offer-option-tile-extra__title">{title}</div>
      {(!items || items.length === 0) && (
        <div className="offer-option-tile-extra__list-item offer-option-tile-extra__list-item_empty">
          None
        </div>
      )}
      {items &&
        items.length > 0 &&
        items.map(item => (
          <div
            key={item as React.Key}
            className="offer-option-tile-extra__list-item"
          >
            {iconElement}
            {item}
          </div>
        ))}
    </div>
  </div>
);

export default OfferOptionTileExtra;
